import { ReducerBuilder } from "../../utils/redux/reducer-builder";
import { CompanyProfileState, CompanyProfileActionTypes, INITIAL_STATE, GroupUser, CompanyProfile, Invite } from "./company-profile.types";


const reduxBuilder = new ReducerBuilder<CompanyProfileState>(INITIAL_STATE);

/* COMPANY PROFILE */
reduxBuilder.addMutableReducer(CompanyProfileActionTypes.GET_COMPANY_PROFILE, (state) => {
    state.companyProfile.loading = true;
    state.companyProfile.error = null;
});

reduxBuilder.addMutableReducer<CompanyProfile>(CompanyProfileActionTypes.GET_COMPANY_PROFILE_SUCCESS, (state, payload) => {
    state.companyProfile.loading = false;
    state.companyProfile.data = payload;
});

reduxBuilder.addMutableReducer<any>(CompanyProfileActionTypes.GET_COMPANY_PROFILE_ERROR, (state, error) => {
    state.companyProfile.loading = false;
    state.companyProfile.error = error;
});

/* GROUP USERS   */
reduxBuilder.addMutableReducer(CompanyProfileActionTypes.GET_GROUP_USERS, (state) => {
    state.groupUsers.loading = true;
    state.groupUsers.error = null;
});

reduxBuilder.addMutableReducer<GroupUser[]>(CompanyProfileActionTypes.GET_GROUP_USERS_SUCCESS, (state, payload) => {
    state.groupUsers.loading = false;
    state.groupUsers.data = payload;
});

reduxBuilder.addMutableReducer<any>(CompanyProfileActionTypes.GET_GROUP_USERS_ERROR, (state, error) => {
    state.groupUsers.loading = false;
    state.groupUsers.error = error;
});

/* INVITES */
reduxBuilder.addMutableReducer(CompanyProfileActionTypes.GET_INVITES, (state) => {
    state.invites.loading = true;
    state.invites.error = null;
});

reduxBuilder.addMutableReducer<Invite[]>(CompanyProfileActionTypes.GET_INVITES_SUCCESS, (state, payload) => {
    state.invites.loading = false;
    state.invites.data = payload;
});

reduxBuilder.addMutableReducer<any>(CompanyProfileActionTypes.GET_INVITES_ERROR, (state, error) => {
    state.invites.loading = false;
    state.invites.error = error;
});

reduxBuilder.addMutableReducer(CompanyProfileActionTypes.REMOVE_TEAMATE, (state, payload) => {
    state.removedTeamate.error = false;
    state.removedTeamate.loading = true;
});

reduxBuilder.addMutableReducer(CompanyProfileActionTypes.REMOVE_TEAMATE_SUCCESS, (state, payload) => {
    state.removedTeamate.error = false;
    state.removedTeamate.loading = false;
});

reduxBuilder.addMutableReducer(CompanyProfileActionTypes.REMOVE_TEAMATE_ERROR, (state, payload) => {
    state.removedTeamate.error = true;
    state.removedTeamate.loading = false;
});

export default reduxBuilder.build();
